"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isIncludesOneof = exports.isUrlIncludes = void 0;
const isUrlIncludes = (str) => window.location.href.includes(str);
exports.isUrlIncludes = isUrlIncludes;
const isIncludesOneof = (list) => {
    const includes = list.filter((elem) => {
        return (0, exports.isUrlIncludes)(elem);
    });
    return includes.length !== 0 ? true : false;
};
exports.isIncludesOneof = isIncludesOneof;
